import type { ValueOf } from '../util/typeUtils';

export const USER_COMMANDS = {
    addBucket: 'addBucket',
    appointDelegate: 'appointDelegate',
    changeAvatar: 'changeAvatar',
    changeEmail: 'changeEmail',
    changeEuropaceCredentials: 'changeEuropaceCredentials',
    changeGender: 'changeGender',
    changeName: 'changeName',
    changeOwnedBuckets: 'changeOwnedBuckets',
    changePartnerId: 'changePartnerId',
    changePassword: 'changePassword',
    changePersonalSettings: 'changePersonalSettings',
    changePhone: 'changePhone',
    changeProcheckId: 'changeProcheckId',
    changeRole: 'changeRole',
    changeSecret: 'changeSecret',
    changeSMTP: 'changeSMTP',
    changeTitle: 'changeTitle',
    create: 'create',
    deactivate: 'deactivate',
    delete: 'delete',
    deleteAdviserAbsence: 'deleteAdviserAbsence',
    enter: 'enter',
    exit: 'exit',
    limit: 'limit',
    limitTeamMember: 'limitTeamMember',
    lock: 'lock',
    register: 'register',
    removeBucket: 'removeBucket',
    resetPassword: 'resetPassword',
    resetSecret: 'resetSecret',
    revokeDelegate: 'revokeDelegate',
    revokeLimit: 'revokeLimit',
    revokeTeamMemberLimit: 'revokeTeamMemberLimit',
    setAdviserAbsence: 'setAdviserAbsence',
    setCertificate: 'setCertificate',
    unlock: 'unlock',
} as const;

export type USER_COMMAND = ValueOf<typeof USER_COMMANDS>;
